import { render, staticRenderFns } from "./AddAdmin.vue?vue&type=template&id=2bda0196&"
import script from "./AddAdmin.vue?vue&type=script&lang=js&"
export * from "./AddAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports